import { combine, withMemo } from 'react-hooks-combine'

import TableControllerComponent from './component'
import { TableContextController } from './controllers/context.controller'

export const TableController = combine(
  withMemo('contextController', () => new TableContextController(), [])
)(TableControllerComponent)
